import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import { Typography } from '@material-tailwind/react';
import MapContainer from '../components/MapContainer';
import ubiarea from "../assets/images/area.webp"

export function Location() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="w-full relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Location"} />

        <section className="w-full container mx-auto py-12 px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Location
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              The event will take place at <strong>Faculdade de Ciências da Saúde </strong>, located in Colégio do Espírito Santo at Rua do Cardeal Rei, 18.
            </Typography>
          </div>
          <MapContainer />

          <div className="mt-10">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Convenient parking and access
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              The <strong>Faculdade de Ciências da Saúde </strong>, has many facilities in terms of parking, location and proximity to places to eat.
            </Typography>
          </div>
          <div className="w-full flex justify-center mt-12" >
            <img
              src={ubiarea}
              alt="ubi_parking_area"
              className="h-full w-full max-w-[600px] object-cover"
            />
          </div>


        </section>
        <Footer />

      </div>
    </>
  );
}
